document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-size-method]').forEach(function (root) {
    var sectionId = root.dataset.sectionId;
    var measurementsBlock = document.querySelector(
      '[data-measurements-block][data-section-id="' + sectionId + '"]'
    );
    var breedPicker = root.querySelector('[data-breed-picker]');
    var breedSelect = root.querySelector('[data-breed-select]');
    var genderSelect = root.querySelector('[data-gender-select]');
    var dataEl = root.querySelector('[data-breed-data]');
    var radios = root.querySelectorAll('[data-size-method-radio]');
    var valuesDisplay = root.querySelector('[data-breed-values-display]');
    var valuesGrid = root.querySelector('[data-breed-values-grid]');

    if (!measurementsBlock || !dataEl) return;

    var breedData = {};
    try { breedData = JSON.parse(dataEl.textContent); }
    catch (e) { console.error('[size-method] bad JSON', e); }

    var manualInputs = measurementsBlock.querySelectorAll('input');
    var genderLabels = { f: 'Tispe', m: 'Hann' };

    var raseInput = measurementsBlock.querySelector('[name="properties[Rase]"]');
    var kjonnSelect = measurementsBlock.querySelector('[name="properties[Kjønn]"]');
    var methodProp = measurementsBlock.querySelector('[name="properties[_size_method]"]');

    // Bygg kart: property-label (f.eks. "Omkrets hals") -> faktisk <input>-element.
    // Dette er de SAMME feltene brukeren ville fylt ut manuelt, og som yarn-calculator.js
    // leser via getElementById og lytter på "input"-events for.
    var inputsByLabel = {};
    manualInputs.forEach(function (input) {
      var match = /properties\[(.+)\]/.exec(input.name || '');
      if (match) inputsByLabel[match[1]] = input;
    });

    function dispatchInputEvent(el) {
      el.dispatchEvent(new Event('input', { bubbles: true }));
      el.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function clearManualInputs() {
      Object.keys(inputsByLabel).forEach(function (label) {
        var input = inputsByLabel[label];
        input.value = '';
        input.readOnly = false;
        dispatchInputEvent(input);
      });

      if (raseInput) {
        raseInput.value = '';
        raseInput.readOnly = false;
        dispatchInputEvent(raseInput);
      }
      if (kjonnSelect) {
        kjonnSelect.value = 'Ikke oppgitt';
        kjonnSelect.style.pointerEvents = '';
        kjonnSelect.style.opacity = '';
        dispatchInputEvent(kjonnSelect);
      }
      if (methodProp) {
        methodProp.value = 'manual';
        dispatchInputEvent(methodProp);
      }
    }

    function toggleMethod(method) {
      if (method === 'manual') {
        measurementsBlock.style.display = '';
        breedPicker.style.display = 'none';
        clearManualInputs();
        if (valuesDisplay) valuesDisplay.style.display = 'none';
      } else {
        measurementsBlock.style.display = 'none';
        breedPicker.style.display = '';
      }
    }

    function availableGendersFor(breedHandle) {
      var genders = [];
      Object.keys(breedData).forEach(function (key) {
        var parts = key.split('__');
        if (parts[0] === breedHandle) genders.push(parts[1]);
      });
      return genders;
    }

    function populateGenderSelect(breedHandle) {
      var genders = availableGendersFor(breedHandle);
      genderSelect.innerHTML = '<option value="">Velg kjønn …</option>';
      genders.forEach(function (g) {
        var opt = document.createElement('option');
        opt.value = g;
        opt.textContent = genderLabels[g] || g;
        genderSelect.appendChild(opt);
      });
      genderSelect.style.display = genders.length ? '' : 'none';
    }

    function renderValuesDisplay(values) {
      if (!valuesDisplay || !valuesGrid) return;

      if (!values) {
        valuesDisplay.style.display = 'none';
        valuesGrid.innerHTML = '';
        return;
      }

      valuesGrid.innerHTML = '';
      Object.keys(values).forEach(function (label) {
        var labelEl = document.createElement('div');
        labelEl.style.opacity = '0.75';
        labelEl.textContent = label;

        var valueEl = document.createElement('div');
        valueEl.style.fontWeight = '600';
        valueEl.textContent = values[label] + ' cm';

        valuesGrid.appendChild(labelEl);
        valuesGrid.appendChild(valueEl);
      });

      valuesDisplay.style.display = '';
    }

    function applyValues() {
      var key = breedSelect.value + '__' + genderSelect.value;
      var values = breedData[key];
      if (!values) {
        renderValuesDisplay(null);
        return;
      }

      // Fyll verdiene DIREKTE inn i de originale measurement-feltene.
      // Dette gjør at:
      // 1. yarn-calculator.js sin getElementById(...)-oppslag finner riktige verdier
      // 2. "input"-eventet trigger automatisk garnberegning
      // 3. Feltene sendes normalt til handlekurven med properties[...]-navnene sine
      Object.keys(values).forEach(function (label) {
        var input = inputsByLabel[label];
        if (!input) return;
        input.value = values[label];
        input.readOnly = true; // synlig/logisk låst, men submitter fortsatt normalt
      });

      renderValuesDisplay(values);

      // Fyll Rase/Kjønn med det kunden faktisk valgte, og flagg at dette
      // er en rasegjennomsnitt-bestilling (ikke en ekte individuell måling)
      if (raseInput) {
        var breedLabel = breedSelect.selectedOptions[0]
          ? breedSelect.selectedOptions[0].textContent
          : '';
        raseInput.value = breedLabel;
        raseInput.readOnly = true;
        dispatchInputEvent(raseInput);
      }
      if (kjonnSelect) {
        kjonnSelect.value = genderLabels[genderSelect.value] || 'Ikke oppgitt';
        kjonnSelect.style.pointerEvents = 'none';
        kjonnSelect.style.opacity = '0.75';
        dispatchInputEvent(kjonnSelect);
      }
      if (methodProp) {
        methodProp.value = 'breed_average';
        dispatchInputEvent(methodProp);
      }

      // Trigger event på ALLE måltallsfeltene (ikke bare det første), slik at
      // både yarn-calc og eventuelle Shopify-interne lyttere (f.eks. dynamiske
      // betalingsknapper som Shop Pay) fanger opp de oppdaterte verdiene.
      Object.keys(values).forEach(function (label) {
        var input = inputsByLabel[label];
        if (input) dispatchInputEvent(input);
      });

      document.dispatchEvent(new CustomEvent('measurements:updated', { detail: values }));
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () { toggleMethod(this.value); });
    });

    breedSelect.addEventListener('change', function () {
      renderValuesDisplay(null);
      genderSelect.value = '';
      if (this.value) {
        populateGenderSelect(this.value);
      } else {
        genderSelect.style.display = 'none';
      }
    });

    genderSelect.addEventListener('change', applyValues);

    toggleMethod('manual'); // init
  });
});